module.exports = __webpack_public_path__ + "img/Olsson.f8e1c9d6.jpeg";